        varying vec3 vWorldPosition;
        varying vec2 vUv;
        void main() {
            vUv = uv;
            vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
            csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }